<div class="conteudo">
  
    <div class="content">
      <p-table #dt [value]="dealersDados" dataKey="id" selectionMode="single" 
        styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" 
        [loading]="loading" [columns]="selectedColumns" [paginator]="true" [rows]="10" 
        [scrollable]="true" scrollDirection="horizontal" [style]="{ 'width': '100%' }" 
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'relatorioVeiculos.veiculoEstoque.mostrandoRegistros' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]" [globalFilterFields]="[
                                'dealer',
                                'chassi',
                                'marca',
                                'modelo',
                                'valorVenda',
                                'corExterna',
                                'acabamentoInterno',
                                'anoModelo',
                                'situacao',
                                'status',
                                'tempoEstoque']" 
        (customSort)="customSort($event)" id="excel-table">
        <!-- COLGROUP para controle de larguras -->
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col *ngFor="let col of selectedColumns" [style.width]="col.width" />
          </colgroup>
        </ng-template>
        
        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-left mr-1">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="{{'relatorioVeiculos.veiculoEstoque.filtroGeral' | translate}}" />
            </span>

            <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
              optionLabel="headerBr"
              selectedItemsLabel="{{'relatorioVeiculos.veiculoEstoque.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'relatorioVeiculos.veiculoEstoque.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
            <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
              optionLabel="headerGb"
              selectedItemsLabel="{{'relatorioVeiculos.veiculoEstoque.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'relatorioVeiculos.veiculoEstoque.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
            <button class="btn btn-outline-secondary btn-sm mb-2 float-right" (click)="exportarExcel()">
              <em class="fa fa-download fa-xs"></em>
              Export Excel
            </button>
            
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [translate]="getTranslate(col.header)" class="text-center"
              [pSortableColumn]="col.field" *ngFor="let col of columns" 
              (onSort)="customSort($event)"
              style="background-color:black;color:white;position:sticky;top:0;z-index:2;">
              {{col.header}}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dealer let-columns="columns">
          <tr>
            <td class="text-center" *ngFor="let col of columns">
              <div [ngClass]="{'dealer': col.field === 'nome'}">
                <ng-container *ngIf="col.field === 'dtUltimaAtual'">
                  {{dealer.dtUltimaAtualFormatted}}
                </ng-container>
                <ng-container *ngIf="col.field !== 'dtUltimaAtual'">
                  {{dealer[col.field]}}
                </ng-container>
                <!-- <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dealer)"></ng-container> -->
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
</div>
